<template>
    <div class="weather-fill">
        <el-form ref="Formlist" :model="fillForm" :rules="rules" label-width="110px" class="demo-fillForm" style="overflow: hidden;" label-position="left">
            <el-form-item label="所属类别" prop="industryType">
                <el-select v-model="fillForm.industryType" placeholder="请选择所属类别" @change="changetype">
                    <el-option v-for="item in options" :key="item.code" :label="item.name" :value="item.code">
                    </el-option>
                </el-select>
                <label style="margin-left: 30px;margin-right: 10px;">位于建成区</label>
                <el-checkbox v-model="fillForm.isUrban"></el-checkbox>
                <label style="margin-left: 30px;margin-right: 10px;">属于免停产企业</label>
                <el-checkbox v-model="fillForm.isAvoid" @change="changeMStop"></el-checkbox>
                <label style="margin-left: 30px;margin-right: 10px;">是否错峰生产</label>
                <el-checkbox v-model="fillForm.isStagger"></el-checkbox>
            </el-form-item>
        </el-form>
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
            <el-tab-pane label="供暖期" name="first">
                <div class="default-table" id="defaultTab" style="overflow-x: auto">
                    <div style="width:auto;height:auto;">
                        <noheating @change="changeHeating" ref="changeHeating" :changeFalse="changeFalse" :emissionData="heatingData"></noheating>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="非供暖期" name="second">
                <div class="default-table" id="defaultTab1" style="overflow-x: auto">
                    <div style="width:auto;height:auto">
                        <noheating @change="changeNoneHeating" ref="changeNoneHeating" :changeFalse="changeFalse" :emissionData="noneHeatingData"></noheating>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import emissTable from "../../components/weather/emissTable";
import measureTable from "../../components/weather/measureTable";
import emer from "../../data/emer/weather.js";
import noheating from "./noheating1.vue";
import Apis from '../../data/api';
export default {
    data() {
        return {
            isValidateForm: true,
            activeName2: "first",
            measures: "",
            switchState: true,
            fillForm: {
                // 行业类型
                industryType: "",
                // 排放数据
                emissionData: [],
                // 是否免减排企业，
                isAvoid: false,
                // 预案ID
                planId: "",
                // 是否属于建成区内
                isUrban: false,
                // 是否错峰生产
                isStagger: false,
            },
            stateFalse: "",
            stateFalse1: "",
            options: "",
            rules: {
                industryType: [{
                    type: "number",
                    required: true,
                    message: "请选择行业",
                    trigger: "change"
                }],
                keyPollutants: [{
                    type: "array",
                    required: true,
                    message: "请至少选择一项主要污染物",
                    trigger: "change"
                }]
            },
            listobj: [],
            changeFalse: false,
            preData:{},
            heatingData:{},
            noneHeatingData:{}
        };
    },
    created() {
        Apis.getEnv().then((resp) => {
            this.isValidateForm = resp.isValidate;
            if (typeof resp.isValidate === "string") {
                this.isValidateForm = resp.isValidate === "true" ? true : false;
            }
        });
        this.getTypelist();

        if (!sessionStorage.planIdval) return
        let planId = sessionStorage.planIdval
        this.get_heavypoll_detail({
            planId: planId
        })
    },
    mounted() {
        document.getElementById("canvas").style.display = "none";
        let ccc = document.body.clientWidth;
        document.getElementById("defaultTab").style.width = ccc - 50 + "px";
    },
    watch: {
        preData: {
            handler() {
                Object.assign(this.fillForm, this.preData);
            },
            deep: true
        }
    },
    methods: {
        get_heavypoll_detail(params) {
            (async() => {
                try {
                    let info = await emer.heavypoll_detail(params)
                    if(info.status) {
                        if(info.data.industryType){
                            this.preData = info.data
                            if(info.data.emissionData){
                                this.heatingData = this.preData.emissionData[0]?this.preData.emissionData[0]:{};
                                this.noneHeatingData = this.preData.emissionData[1]?this.preData.emissionData[1]:{};
                            }
                        }
                    }
                } catch (err) {
                    this.$message.error('网络异常，请稍后重试')
                }
            })()
        },
        // css
        changeCSS() {
            document.getElementById("canvas").style.display = "none";
            let ccc = document.body.clientWidth;
            document.getElementById("defaultTab1").style.width = ccc - 50 + "px";
        },
        // 切换
        handleClick(tab, event) {
            tab.index == 1 ? this.changeCSS() : "";
        },
        // 监听
        changeMStop(data) {
            this.fillForm.isAvoid == false ?
                (this.changeFalse = false) :
                (this.changeFalse = true);
        },
        getTypelist(params) {
            (async () => {
                let getState = await emer.industytype_list(params);
                if (getState.status) {
                    this.options = getState.data;
                }
            })();
        },
        // 下拉选中的数据类型
        changetype(val) {
            this.fillForm.industryType = val;
        },
        //供暖期的数据
        changeHeating(val) {
            this.fillForm.emissionData[0] = val.emissionData[0];
            this.fillForm.emissionData[0].period = 1;
        },
        // 非供暖的数据
        changeNoneHeating(val) {
            this.fillForm.emissionData[1] = val.emissionData[0];
            this.fillForm.emissionData[1].period = 2;
        },
        //提交信息
        submitForm() {
          this.fillForm.planId = sessionStorage.planIdval;
            if(!this.isValidateForm) {
                this.$emit("change", this.fillForm);
                return;
            }
          if(!this.fillForm.emissionData || !this.fillForm.emissionData[0]){
               this.$message.warning("请填写供暖期数据");
               return;
          }
          if(!this.fillForm.emissionData || !this.fillForm.emissionData[1]){
               this.$message.warning("请填写非供暖期数据");
               return;
          }
          this.$emit("change", this.fillForm);
        }
    },
    components: {
        emissTable,
        measureTable,
        noheating
    }
};
</script>

<style scoped>
.weather-fill {
    text-align: left;
    margin-top: 20px;
}

.default-table {
    width: 100%;
    height: 500px;
    margin-bottom: 20px;
}

/* 公共样式 */

.de-table-wrap {
    width: 100%;
    height: 100%;
    position: relative;
    display: inline-flex;
    background: #fff;
    text-align: center;
}

.de-table-wrap span {
    width: 100%;
    height: 100%;
    text-align: center;
    color: #333;
}

.de-table-lt {
    flex: 1;
    background: #fff;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    border-top: 0;
}

.de-table-ct {
    flex: 4;
    border-right: 1px solid #ccc;
    display: flex;
    flex-direction: column;
}

.de-table-rt {
    flex: 8;
    display: flex;
    flex-direction: column;
}

.de-table-top {
    flex: 1;
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc;
    display: flex;
    flex-direction: column;
}

.de-table-top-head {
    flex: 1;
    border-bottom: 1px solid #ccc;
    display: flex;
}

.de-table-top-list {
    /*flex: 1;*/
    display: flex;
}

.de-table-bot {
    flex: 3;
    display: flex;
    flex-direction: column;
}

.de-table-bot-head {
    flex: 1;
    border-bottom: 1px solid #ccc;
    display: flex;
}

.de-table-bot-con {
    flex: 8;
    display: flex;
}

.de-table-col {
    flex: 1;
    border-right: 1px solid #ccc;
    display: flex;
    flex-direction: column;
}

.de-table-row {
    flex: 1;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
}

.bd-none {
    border-right: 0;
}

.bg-red {
    background: red;
    border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// fill.vue?884e8122